export const PAYAUTHORITY_ROUTING = [
    {
        path: '/payauthority',
        name: 'payauthority',
        meta: {
            auth: true,
            breadcrumb: [
                { name: 'Thanh toán ủy quyền', pathName: 'payauthority', icon: 'fa fa-credit-card' },
            ]
        },
        component: () => import('./PayAuthority.vue'),
        redirect: { name: 'payauthority-index' },
        children: [
            { 
                path: '/thanh-toan-uy-quyen.html',
                name: 'payauthority-index',
                component: () => import('./components/main-payauthority/MainPayAuthority.vue')
            },
            {
                path: '/thanh-toan-uy-quyen/:id',
                name: 'payauthority-detail',
                meta: {
                    breadcrumb: [
                        { name: 'Chi tiết ủy quyền', pathName: 'payauthority-detail', icon: 'fa fa-bar-chart' },
                ] },
                component: () => import('./components/detail-payauthority/DetailPayAuthoriry.vue'),
            },
            {
                path: '/khieu-nai-thanh-toan-uy-quyen/:orderId/:orderType',
                name: 'payauthority-complain',
                meta: {
                    breadcrumb: [
                        { name: 'Khiếu nại TT ủy quyền', pathName: 'payauthority-complain', icon: 'fa fa-bar-chart' },
                ] },
                component: () => import('../order/components/complain-order/ComplainOrder.vue'),
            },
            {
                path: '/khieu-nai-thanh-toan-uy-quyen/:orderId/:complainId/:orderType',
                name: 'detail-payauthority-complain',
                meta: {
                    breadcrumb: [
                        { name: 'Khiếu nại TT ủy quyền', pathName: 'detail-payauthority-complain', icon: 'fa fa-bar-chart' },
                    ]
                },
                component: () => import('../order/components/complain-order/ComplainOrder.vue')
            }
        ]
    }
];